import { defineStore } from "pinia";
import { useHttpStore } from "@/stores/http";

export const useReportsStore = defineStore("reports", () => {
  const httpStore = useHttpStore()

  const getReports = (filter) => {
    var params = {
      Filter: filter
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "Reports/GetReports", params, {
          showLoading: true,
          timeout: 0
        })
        .then((res) => {
          resolve(res)
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  const getReportData = (report, downloadOnly, isCustomReport = false) => {
    var params = {
      Report: JSON.stringify(report),
      DownloadOnly: downloadOnly,
      IsCustomReport: isCustomReport
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "Reports/GetReportData", params, {
          showLoading: true,
          timeout: 0          
        })
        .then((res) => {
          resolve(res)
        })
        .catch((error) => {
          reject(error);
        });
    })
  }

  const formatHeader = (str) => {
    str = str.charAt(0).toUpperCase() + str.slice(1)

    // Use a regex to split the string at camel case boundaries
    const words = str.replace(/([a-z])([A-Z])/g, '$1 $2')
                       .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
                       .split(' ')

    // Capitalize the first letter of each word and join them
    const result = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1)
    }).join(' ')

    return result
   }

  return {
    getReports,
    getReportData,
    formatHeader
  };

})